import Marquee from "react-fast-marquee";
import { AFFILIATIONS } from "../../lib/content";

export default function AffiliationMarquee() {
  return (
    <section id="marquee" className="relative py-10 border-y border-gold/10 bg-surface/40" data-testid="marquee-section">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {AFFILIATIONS.map((a, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-4xl text-muted-foreground/70 tracking-wide px-10">
              {a}
            </span>
            <span className="text-gold text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
